import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import dayjs from 'dayjs'
import React from 'react'

interface Props {
  backgroundColor: string
  backgroundImage: string
  sideImage: { imgSrc: string; altText: string }
  builderSideImage: any
  isSideImage: boolean
  blogTitle: string
  blogDate: string
  blogCategory: string
}

const BlogHero = ({
  backgroundColor,
  backgroundImage = '',
  sideImage,
  builderSideImage,
  isSideImage,
  blogTitle,
  blogDate,
  blogCategory
}: Props) => {
  const dateFormatted = (date: any) => {
    const dateObj = new Date(date)
    const dateStr = dayjs(dateObj).format('D MMMM YYYY')
    return dateStr
  }
  // extract public id for Cloudinary
  const [, publicId = ''] =
    sideImage?.imgSrc?.match(/^https:\/\/res\.cloudinary\.com\/different-dog\/image\/upload\/[a-z0-9]+\/(.*)\..*$/) ||
    []
  return (
    <div
      className="bg-image-none relative md:bg-cover md:bg-bottom md:bg-no-repeat"
      style={{ backgroundColor, backgroundImage: `url(${backgroundImage ?? ''})` }}
    >
      <main className="mx-auto md:flex -mt-12 xl:-mt-20">
        {isSideImage && (
          <div className="md:w-5/12">
            <div className="relative h-full rounded-lg shadow-lg sm:mx-auto">
              <CdnImage
                className="w-full object-cover"
                url={builderSideImage}
                alt={sideImage?.altText}
                steps={[550, 650, 750, 850, 950, 1050]}
              />

              {/* {builderSideImage ? (
                <CdnImage
                  className="w-full object-cover"
                  url={builderSideImage}
                  alt={sideImage?.altText}
                  steps={[550]}
                />
              ) : (
                <>
                  {sideImage?.imgSrc.includes('https://res.cloudinary.com') ? (
                    <CloudinaryImage
                      className="w-full object-cover"
                      publicId={publicId.replace(/%20/g, ' ')}
                      alt={sideImage?.altText}
                      steps={[550]}
                    />
                  ) : (
                    <img
                      className="index-2 relative w-full object-cover"
                      src={sideImage?.imgSrc}
                      alt={sideImage?.altText}
                    />
                  )}
                </>
              )} */}
            </div>
          </div>
        )}
        <div className={`${isSideImage ? 'md:w-7/12' : 'py-16 md:w-full'} p-8`}>
          <div className="mx-auto flex h-full flex-col justify-center text-primary">
            <h1 className="text-3xl leading-tight md:text-4xl">{blogTitle}</h1>
            <div className="flex gap-4 py-4 text-sm">
              <span>{dateFormatted(blogDate)}</span>
              <span className="uppercase underline">{blogCategory}</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default BlogHero

Builder.registerComponent(BlogHero, {
  name: 'BlogHero',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'sideImage',
      type: 'object',
      subFields: [
        {
          name: 'imgSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        {
          name: 'altText',
          type: 'text',
          defaultValue: ''
        }
      ],
      defaultValue: { imgSrc: '', altText: '' }
    },
    {
      name: 'builderSideImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'isSideImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'blogTitle',
      type: 'text',
      defaultValue: 'Blog 1'
    },
    {
      name: 'blogDate',
      type: 'date',
      defaultValue: ''
    },
    {
      name: 'blogCategory',
      type: 'string',
      defaultValue: 'Advice'
    }
  ]
})
